export function openPlusOverlay(overlayAction) {
  return {
    type: 'OPEN_PLUS_OVERLAY',
    overlayAction: overlayAction
  };
}
export function closePlusOverlay() {
  return {
    type: 'CLOSE_PLUS_OVERLAY'
  };
}